import { Box, Paper, Stack, Typography, colorsPalette } from '@lingoda/ui';
import { CurriculumFilter, useStoreContext } from '../../../components';
import { type PackageLayoutProps } from '../types';

const TabletListLayout = ({
    footerMessage,
    children,
}: React.PropsWithChildren<PackageLayoutProps>) => {
    const { filtersOptions, filtersState, updateFilter } = useStoreContext();
    const showCurriculumFilter = filtersState && filtersOptions.sectionCurriculums.length > 1;

    return (
        <Paper variant="outlined" sx={{ p: 4 }}>
            <Stack direction="column" spacing={3}>
                {showCurriculumFilter && (
                    <Box alignSelf="flex-end">
                        <CurriculumFilter
                            options={filtersOptions.sectionCurriculums}
                            selectedSlug={filtersState.curriculumSlug}
                            onFilterUpdate={updateFilter}
                        />
                    </Box>
                )}

                <Box>{children}</Box>

                {footerMessage && (
                    <Typography variant="body1" htmlColor={colorsPalette.blackAlpha[60]}>
                        {footerMessage}
                    </Typography>
                )}
            </Stack>
        </Paper>
    );
};

export default TabletListLayout;
